import Icon from "@client/controls/Icon/component";
import { IconType } from "@client/types";
import { SystemColor } from "@common/declarations";
import classnames from "classnames";
import * as React from "react";

import "./style.less";

export interface RateProps {
  className?: string;
  onClick?: (rate: number) => void;
  rate: number;
  color?: SystemColor;
}

const Rate = (props: RateProps) => {
  const v = Math.min(Math.max(0, props.rate), 10) / 2;
  return (
    <div className={classnames("wsc_rate rate", props.className)}>
      {Array.from({ length: 5 }, (_, i) => (
        <Icon
          key={i}
          iconClassName={v >= i + 1 ? IconType.StarSolid : v > i ? IconType.StarHalf : IconType.Star}
          onClick={props.onClick ? () => props.onClick!((i + 1) * 2) : undefined}
          color={props.color}
        />
      ))}
    </div>
  );
};

export default Rate;

export type RatingSurveyProps = {
  onClick: (rating: number) => void;
  question?: string;
  value: number | null;
};

export const RatingSurvey = (props: RatingSurveyProps) => {
  const [rating, setRating] = React.useState<number | null>(props.value);

  React.useEffect(() => setRating(props.value), [props.value]);

  const content = React.useMemo(() => {
    let content: any[] = [];
    for (let i = 1; i <= 10; i++) {
      content.push(
        <li
          key={i}
          className={`${i <= 6 ? "rate_low" : i <= 8 ? "rate_middle" : "rate_high"} ${rating === i ? "checked" : ""}`}
          onClick={() => {
            setRating(i);
            props.onClick(i);
          }}
        >
          <span>{i}</span>
        </li>
      );
    }

    return content;
  }, [rating, setRating, props.onClick]);

  return (
    <div className="wsc_rate_survey">
      {props.question && <p>{props.question}</p>}
      <ul>{content}</ul>
      <div>
        <Icon iconClassName="fal fa-thumbs-down fa-inverse"></Icon>{" "}
        <Icon iconClassName="fal fa-thumbs-up fa-inverse"></Icon>
      </div>
    </div>
  );
};
